import features from '../config/features'

export default feature => {
  return features[feature] === true
}
